import FormService from '../../../core/services/FormService';
import NotificationService from '../../../core/services/NotificationService';
import FetchService from '../../../core/services/FetchService';
import { action, extendObservable } from 'mobx';
import moment from 'moment';
import { isRequired } from '../../../core/validations';
import ContractListService from './ContractListService';

class ContractActivationDialogService {
  form = new FormService();
  submit = new FetchService();

  constructor() {
    extendObservable(this, {
      isOpen: false,
    });
    this.form.validations = {
      startsAt: [isRequired],
    };
  }

  open = action(({ id, documentNumber }) => {
    this.isOpen = true;
    this.form.setInitialValues({
      id,
      documentNumber,
      startsAt: moment().utc(),
      endsAt: null,
    });
  });

  close = action(() => {
    this.isOpen = false;
  });

  handleActivate = action(() => {
    this.form.setSubmitted();
    if (this.form.errors) {
      NotificationService.addNotification('Fill the required fields', 'error');
      return;
    }
    this.submit
      .fetch({
        method: 'put',
        url: `/contracts/${this.form.getValue('id')}/activate`,
        apiVersion: 'v2',
        body: {
          startsAt: this.form.getValue('startsAt').utc().startOf('day'),
          ...(this.form.getValue('endsAt') && {
            endsAt: this.form.getValue('endsAt').utc().endOf('day'),
          }),
        },
      })
      .then(() => {
        if (this.submit.data) {
          NotificationService.addNotification(
            `Contract ${this.form.getValue(
              'documentNumber'
            )} activation request successfully completed. The contract will be activated in a few minutes.`,
            'success'
          );
          this.isOpen = false;
          ContractListService.load();
        }
        if (this.submit.error) {
          NotificationService.addNotification(this.submit.error || `Error activating contract.`, 'error');
        }
      });
  });
}

const contractActivationDialogService = new ContractActivationDialogService();

export default contractActivationDialogService;
